import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { dateFormat,utcDateTimeWithTimeZoneWithFormat, compareDateWithCurrent } from "../../services/Util";
import Constants from "../../Constants";
import $ from "jquery";
import { WatchIcon } from "../../AppIcons";
export default function UserTaskList(prop) {
  const showBid = () => {
    prop.funct("bids");
  };
  const custBootstrapDataRedux = useSelector(
    (store) => store.customer_bootstrap_data
  ).value;
  const navigate = useNavigate();
  const getMyTaskLink = (task) => {
    var url = "/project";
    var urlLastPart = ''
    switch (task.type.originalEnum) {
      case "CONFIGURE_PROJECT_SOURCE" : 
      url = `/${task.url.substring(1)}`;
      return (
        <Link className="linkFont100" to="" onClick={(e) => {e.preventDefault();navigate(url)}}>
          {task.displayName}
        </Link>
      );
      case "REVIEW_PROJECT_REQUEST":
        url = `/${task.url.substring(1)}`;
      return (
        <Link className="linkFont100" to="" onClick={(e) => {e.preventDefault();navigate(url)}}>
          {task.displayName}
        </Link>
      );
      case "REVIEW_WORKSPACE_USER_REQUEST":
        return (
          <Link className="linkFont100" onClick={(e) => { e.preventDefault(); navigate(`/campaign/${task.workspace.id}`) }}>
            {task.displayName}
          </Link>
        );
      case "CONFIGURE_PROJECT_WORKFLOW" : 
      url = `/${task.url.substring(1)}`;
      return (
        <Link className="linkFont100" to="" onClick={(e) => {e.preventDefault();navigate(url)}}>
          {task.displayName}
        </Link>
      );
      case "SELECT_WINNING_BID":
        return (
          <Link className="linkFont100" onClick={(e) => {e.preventDefault();navigate(`/project/${task.project.id}`,{state:{tab:'bids'}})}}>
            {task.displayName}
          </Link>
        );

      case "RESPOND_TO_CUSTOMER_INTERNAL_PROJECT_REQUEST":
        return (
          <Link className="linkFont100" onClick={(e) => {e.preventDefault();navigate(`/project/${task.project.id}`,{state:{tab:'internalTranslator'}})}}>
            {task.displayName}
          </Link>
        );
      case "SUBMIT_TM_AND_CLOSE_PROJECT" : 
      return (
        <Link className="linkFont100" onClick={(e) => {e.preventDefault();navigate(`/project/${task.project.id}`,{state:{tab:'overView'}})}}>
          {task.displayName}
        </Link>
      );
      case "CUSTOM" :
        url = `/${task?.url.substring(1)}`;
        urlLastPart = url.split("/").pop() 
        if(task.project !== ''){
          return (
            <Link className="linkFont100" 
              to={`/project/${task.project.id}/tasks/${task.id}`}
              onClick={(e) => {
                e.preventDefault();
                navigate(`/project/${task.project.id}/tasks/${task.id}`);
              }}
            >
              {task.displayName}
            </Link>
          );
        }else{
          var newUrl = task.url.replace("#workspace", "/campaign");
          var taskId  = url.split("/").pop()  
          return (
            <Link className="linkFont100" onClick={(e)=>{e.preventDefault();navigate(newUrl,{state:{id:taskId}})}}>
              {task.displayName}
            </Link>)
        }
       

      case "RESPOND_TO_MACHINE_TRANSLATION_QUOTE":
        url = `/${task?.url.substring(1)}`;
        urlLastPart = url.split("/").pop()
        return (
          <Link className="linkFont100" onClick={(e) => {e.preventDefault();navigate(`/project/${task.project.id}`,{state:{tab:'machineTranslation',id:urlLastPart}})}}>
            {task.displayName}
          </Link>
        );

      case "RESPOND_TO_VENDOR_CHANGE_ORDER_BID":
        url = `/${task?.url.substring(1)}`;
        urlLastPart = url.split("/").pop()
        return (
          <Link className="linkFont100" onClick={(e) => {e.preventDefault();navigate(`/project/${task.project.id}`,{state:{tab:'changeOrder',id:urlLastPart}});setTimeout(() => {$('button.active').trigger('focus')}, 300);}}>
            {task.displayName}
          </Link>
        );

      case "RESPOND_TO_CUSTOMER_CHANGE_ORDER_REQUEST":
        url = `/${task?.url.substring(1)}`;
        urlLastPart = url.split("/").pop()
        return (
          <Link className="linkFont100" onClick={(e) => {e.preventDefault();navigate(`/project/${task.project.id}`,{state:{tab:'changeOrder',id:urlLastPart}})}}>
            {task.displayName}
          </Link>
        );

      case "PROJECT_ACCEPT_CANCELLATION":
        return (
          <Link className="linkFont100" onClick={(e) => {e.preventDefault();navigate(`/project/${task.project.id}`,{state:{tab:'bids'}})}}>
            {task.displayName}
          </Link>
        );

      case "REVIEW_APPROVED_ASSET_NOTES":
        url = `/${task.url.substring(1)}`;
        return (
          <Link className="linkFont100" onClick={(e) => {e.preventDefault();navigate(url)}}>
            {task.displayName}
          </Link>
        );

      case "REQUEST_BIDS_FOR_PROJECT":
        url = `/project/${task.project.id}`;
        return (
          <Link className="linkFont100" onClick={(e) => {e.preventDefault();navigate(url)}}>
            {task.displayName}
          </Link>
        );

      case "REVIEW_PROJECT_ASSETS":
        url = `/${task?.url.substring(1)}`;
        var code = ''
        if(task.language !== ''){
          code = task.language.code
        }else{
          code = task?.url.split("/").pop()
        }
        return (
          <Link className="linkFont100" onClick={(e) => {e.preventDefault();navigate(`/project/${task.project.id}`,{state:{tab:'overView',langCode:code}})}}>
            {task.displayName}
          </Link>
        );

      case "DELIVER_PROJECT_ASSETS":
        url = `/${task?.url.substring(1)}`;
        if(task.language !== ''){
          code = task.language.code
        }else{
          code = task?.url.split("/").pop()
        }
        return (
          <Link className="linkFont100"  onClick={(e) => {e.preventDefault();navigate(`/project/${task.project.id}`,{state:{tab:'overView',langCode:code}})}}>
            {task.displayName}
          </Link>
        );

      case "REVISE_PROJECT_ASSETS":
        url = `/${task.url.substring(1)}`;
        return (
          <Link className="linkFont100" onClick={(e) => {e.preventDefault();navigate(url)}}>
            {task.displayName}
          </Link>
        );

      case "ASSIGN_USERS_TO_GROUPS":
        return (
          <Link className="linkFont100" onClick={(e) => {e.preventDefault();navigate(`/settings/user-management`)}}>
            {task.displayName}
          </Link>
        );

      default:
        return "";
    }
  };
  return (
    <>
      <div className="tabitem-list flex-center" key={prop?.id}>
        <div className="flex-center flex-width">
          <div className="date-tag flex-center">
            <strong>{dateFormat(prop?.task?.createdDate?.utcTimestamp, Constants.ONLY_DATE_FORMAT)}</strong>
            <span>{dateFormat(prop?.task?.createdDate?.utcTimestamp, Constants.ONLY_MONTH_FORMAT_NAME)}</span>
          </div>
          <div className="tabitem-text flex-center">
            {prop.use === "dashboard" ? (
              <>
                <strong>{getMyTaskLink(prop.task)}</strong>
                {prop.task.project !== "" ? (
                  <span style={{fontSize: "85.7142857143%"}}>
                    {prop.task.project?.name}{" "}
                    {prop.task.userGroup?.name !== ""
                      ? "(" + prop.task.userGroup?.name + ")"
                      : ""}
                  </span>
                ) : (
                  prop.task.projectRequest !== '' ?
                  <span style={{fontSize: "85.7142857143%"}}>
                    {prop.task.projectRequest?.name}{" "}
                    {prop.task.userGroup?.name !== ""
                      ? "(" + prop.task.userGroup?.name + ")"
                      : ""}
                  </span> : ''
                )}
              </>
            ) : (
              getMyTaskLink(prop.task)
            )}
          </div>
        </div>
        {prop.task.dueDate !== "" ? (
          <div className="assign-due flex-center" aria-label="due today">
            {WatchIcon}
            {prop?.task?.overDue ? 
             prop?.task?.dueToday ? prop?.task?.dueDate?.date +" ( Due Today ) "
              : prop?.task?.dueDate?.date + " ( Overdue ) " 
              : prop?.task?.dueDate?.date }
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
}
